import { EActionState, IRegionGroup } from '@/models';
import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { IDrawerState, initialState } from './state';

export const applicationSlice = createSlice({
	name: '@@application',
	initialState: initialState,
	reducers: {
		INIT_START: state => {
			state.init = EActionState.RUNNING;
		},
		INIT_COMPLETED: (state, action: PayloadAction<IRegionGroup[]>) => {
			state.regions = action.payload;
			state.init = EActionState.COMPLETED;
		},
		INIT_FAILED: state => {
			state.init = EActionState.FAILED;
		},
		SET_DRAWER_OPEN: (state, action: PayloadAction<string>) => {
			Object.entries(state.drawer).forEach(drawer => {
				const [key, value] = drawer;
				value['open'] = key === action.payload.toLowerCase();
			});
		},
		SET_DRAWER_CLOSE: (state, action: PayloadAction<string>) => {
			state.drawer[
				action.payload.toLowerCase() as keyof IDrawerState
			].open = false;
		}
	}
});

export const actionCreator = applicationSlice.actions;
export const reducer = applicationSlice.reducer;
